import { Users, MessageSquare, BookOpen, ArrowRight } from "lucide-react";

const communityFeatures = [
  {
    icon: Users,
    title: "Conexión con otros emprendedores",
    description: "Personas en procesos similares con quienes compartir contexto y avances.",
  },
  {
    icon: MessageSquare,
    title: "Espacio de consultas",
    description: "Entorno para resolver dudas específicas sobre tu proyecto de ecommerce.",
  },
  {
    icon: BookOpen,
    title: "Continuidad en el aprendizaje",
    description: "Mayor contexto y acompañamiento para avanzar con más criterio.",
  },
];

export default function CommunitySection() {
  return (
    <section
      id="comunidad"
      data-testid="community-section"
      className="py-20 md:py-28 bg-[#0A1628] text-white relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Visual */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&auto=format&fit=crop&q=80"
                alt="Entorno de aprendizaje"
                className="w-full rounded-sm"
              />
              
              {/* Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0A1628] to-transparent p-8">
                <p className="text-sm text-gray-300">
                  Entorno de aprendizaje dentro de la propuesta educativa
                </p>
              </div>
            </div>

            {/* Background decoration */}
            <div className="absolute -top-8 -left-8 w-48 h-48 bg-[#D4C4A8]/10 -z-10" />
          </div>

          {/* Right Column - Content */}
          <div className="order-1 lg:order-2">
            <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#D4C4A8] mb-4 block">
              Entorno de aprendizaje
            </span>
            <h2
              className="text-3xl md:text-5xl font-semibold text-white mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              No avanzas solo
            </h2>
            <p className="text-base text-gray-300 leading-relaxed mb-10">
              Además del contenido, muchas personas valoran más una ruta cuando existe 
              conexión, continuidad y un entorno que acompaña el proceso de aprendizaje 
              en Ecommerce. La comunidad y el contexto pueden hacer la diferencia.
            </p>

            {/* Features List */}
            <div className="space-y-6">
              {communityFeatures.map((feature, index) => (
                <div
                  key={index}
                  data-testid={`community-feature-${index}`}
                  className="flex gap-5 group"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-[#D4C4A8]/20 border border-[#D4C4A8]/30 flex items-center justify-center">
                    <feature.icon size={22} className="text-[#D4C4A8]" />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-white mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-400">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Note */}
            <p className="text-xs text-gray-500 mt-8">
              El entorno de comunidad forma parte de la propuesta educativa provista por MINED.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
